import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AppComponent } from "./app.component";

const routes: Routes = [
  { path: "auth", component: AppComponent },
  { path: "gid", loadChildren: "./pages/home/home.module#HomeModule" },
  { path: "", redirectTo: "auth", pathMatch: "full" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
